import React from "react";
import {Grid, Link, Typography} from "@material-ui/core";
import {CommonLoader} from "../../../../../components/Common";
import {PageTitle} from "../../../../../components/formInputs";
import {RecipientsList} from "../../../../../components/ClientNewInvitation/Recipients";
import ConfirmGiftor from "../../../../../components/ClientNewInvitation/Giftor/ConfirmGiftor";
import GiftorInvitation from "../../../../../components/ClientNewInvitation/Giftor/GiftorInvitation";
import RecipientPoliciesList from "../../../Giftor/RecipientPoliciesList";
import {
    useClearRecipientListPage,
    useGetRecipientListPageProps,
    useSetRecipientPageProps,
} from "../../../../../model/PageProps";
import { joinAsFullName } from "../../../../../utils/commonUtils";
import { useHistory } from "react-router-dom";
import { GWT_GEN2_STRATEGY } from "../../../../../constants";


interface GiftorDetailsTabProps {
    clientDetail: any;
}

const GiftorDetailsTab = (props: GiftorDetailsTabProps) => {
    const {clientDetail} = props;
    const navigateTo = useHistory();
    const clientPolicy = clientDetail && clientDetail.client && clientDetail.client.clientPolicies.length > 0 && clientDetail.client.clientPolicies[0];
    const isGWTGen2 = (clientPolicy && clientPolicy.strategyId === GWT_GEN2_STRATEGY)
    const [giftorStatus, setGiftorStatus] = React.useState<boolean>(true);
    const [loading, setLoading] = React.useState(false);
    const carrierId = useGetRecipientListPageProps("carrierId")
    const setPageProp = useSetRecipientPageProps()
    const clearPage = useClearRecipientListPage()
    const handleEditStatus = () => {
        setGiftorStatus(!giftorStatus);
    };
    React.useEffect(()=>{
         clientPolicy.carrierId != carrierId && setPageProp("carrierId", clientPolicy.carrierId)
    },[clientPolicy.strategyId, clientPolicy.carrierId])

    React.useEffect(() => {
        return () => {
            // it should be call only in parent component
            clearPage();
        }
        // Do not add any dependency here
    }, []);

    return (
            <>
                <Grid container spacing={2}>
                    <PageTitle title="Giftor Details"/>

                    {
                            loading &&
                            <CommonLoader/>
                    }
                    {
                            isGWTGen2 && clientDetail.parentUser && 
                            <Grid item>
                              <div className="messageBoxWarning actionRequired">
                                <Typography variant="caption" className="textBlack">
                                   <b>Note:</b> {joinAsFullName(clientDetail)} is a Recipient of a Greatest Wealth Transfer gift from Giftor{" "} 
                                    <Link
                                       onClick={() => navigateTo.push(`${(clientDetail.parentUser.profileUrl)}/giftor-details`)}                        
                                       color="primary"
                                     >
                                        {joinAsFullName(clientDetail.parentUser)}
                                    </Link>
                                </Typography>
                               </div>
                            </Grid>
                    }              
                    {
                            !giftorStatus &&
                            <Grid item xs={12} md={8}>
                                <GiftorInvitation
                                        clientDetail={clientDetail}
                                        giftorStatus={giftorStatus}
                                        handleEditStatus={handleEditStatus}
                                        setGiftorStatus={setGiftorStatus}
                                        setLoading={setLoading}
                                />
                            </Grid>
                    }
                    {
                            giftorStatus &&
                            <Grid item xs={12} md={12}>
                                <ConfirmGiftor onEditStatus={handleEditStatus} clientDetail={clientDetail}/>
                            </Grid>
                    }

                    <Grid item xs={12} md={12}>
                        <RecipientsList parentId={clientDetail && clientDetail.id} setLoading={setLoading} />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <RecipientPoliciesList parentId={clientDetail && clientDetail.id}/>
                    </Grid>
                </Grid>
            </>
    );
};
export default GiftorDetailsTab;